module.exports = __webpack_public_path__ + "static/media/SFMono-Regular.d892da9f.ttf";